<div class="toolbar">
  <p-button
    label="Nuevo panel"
    icon="pi pi-plus"
    (click)="newPanel()"
  ></p-button>
  <p-button
    label="Eliminar seleccionados"
    severity="danger"
    (click)="deleteSelected()"
    *ngIf="selectedRecords?.length"
  ></p-button>
</div>

<p-table
  [value]="records$ | async"
  styleClass="p-datatable-striped"
  sortMode="single"
  [(selection)]="selectedRecords"
  dataKey="id"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="header-checkbox"></th>
      <th pSortableColumn="title" id="header-title">
        Título <p-sortIcon field="title"></p-sortIcon>
      </th>
      <th pSortableColumn="createdAt" id="header-createdAt">
        Creado <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
      <th pSortableColumn="updatedAt" id="header-updatedAt">
        Actualizado <p-sortIcon field="updatedAt"></p-sortIcon>
      </th>
      <th id="header-perfiles">Perfiles permitidos</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr [pSelectableRow]="record">
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"
          ></button>
        </div>
      </td>
      <td [innerHTML]="record.title | markdown"></td>
      <td>{{ record.createdAt | date : "dd MMM yyyy, HH:mm" }}</td>
      <td>{{ record.updatedAt | date : "dd MMM yyyy, HH:mm" }}</td>
      <td>{{ record.allowedProfiles }}</td>
    </tr>
  </ng-template>
</p-table>
